'use client';
import { SwapType } from '@/domain/swap';
import Swap from '@/presentation/components/views/Swap';
import { useSearchParams } from 'next/navigation';
import { Address } from 'nftx.js';

export default function SwapPage() {
  const params = useSearchParams();
  const buyType = (params.get('buyType') ?? undefined) as SwapType;
  const buyToken = (params.get('buyToken') ?? undefined) as Address;
  const buyAmount = (params.get('buyAmount') ?? undefined) as `${number}`;
  const sellType = (params.get('sellType') ?? undefined) as SwapType;
  const sellToken = (params.get('sellToken') ?? undefined) as Address;
  const sellAmount = (params.get('sellAmount') ?? undefined) as `${number}`;
  const buyVaultId = (params.get('buyVaultId') ?? undefined) as string;
  const buyVaultAddress = (params.get('buyVaultAddress') ??
    undefined) as Address;
  const sellVaultId = (params.get('sellVaultId') ?? undefined) as string;
  const sellVaultAddress = (params.get('sellVaultAddress') ??
    undefined) as Address;
  const buyTokenIds = params.getAll('buyTokenIds') as `${number}`[];
  const sellTokenIds = params.getAll('sellTokenIds') as `${number}`[];
  const buyTokenAmounts = params.getAll('buyTokenAmounts').map(Number);
  const sellTokenAmounts = params.getAll('sellTokenAmounts').map(Number);

  return (
    <div className="container flex flex-col justify-center items-center mx-auto mt-8 lg:mt-20 p-4 lg:p-6 ">
      <Swap
        inContainer={true}
        className="shadow-[0_8px_24px_rgb(0_0_0_/_0.08)] dark:shadow-[0_8px_24px_rgb(234_234_234_/_0.05)] rounded-2xl"
        buyType={buyType}
        buyToken={buyToken}
        buyAmount={buyAmount}
        sellType={sellType}
        sellToken={sellToken}
        sellAmount={sellAmount}
        buyVaultAddress={buyVaultAddress}
        buyVaultId={buyVaultId}
        buyTokenIds={buyTokenIds.length ? buyTokenIds : undefined}
        sellTokenIds={sellTokenIds.length ? sellTokenIds : undefined}
        sellVaultId={sellVaultId}
        sellVaultAddress={sellVaultAddress}
        buyTokenAmounts={buyTokenAmounts.length ? buyTokenAmounts : undefined}
        sellTokenAmounts={
          sellTokenAmounts.length ? sellTokenAmounts : undefined
        }
      />
    </div>
  );
}
